import React from "react";
import SelectStepTemplate from "../../../template/SelectStepTemplate";
import useGetMateriais, {
  buildOutrosAviamentos,
} from "../../../template/UseGetMateriais";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";
import EnvioSemFullKitFinalStep from "./EnvioSemFullKitFinalStep";
import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";

const EnvioSemFullKit: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.AVIAMENTO
  );
  const newMateriais = [...materiais, buildOutrosAviamentos()];

  const stepNumber = "2";
  const stepSubTitle = "Selecione o material que será enviado posteriormente.";
  const stepTitle = "Qual aviamento não foi enviado?";

  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={EnvioSemFullKitFinalStep as TipoDivergenciaComponent}
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey="aviamentos"
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default EnvioSemFullKit;
